export default class detailIllust{
    constructor(kv){

        this.kv = kv;
        this.count = 0;
        this.loadedImg = [];

        for(let i=0; this.kv.detailContent.length>i; i++) {
            this.loadedImg[i] = false;
            this.kv.srcList[i] = [];
            this.kv.imgList[i] = [];
        }

        this.setImage;
        this.loop = false;

    }

    set(){

        if(Useragnt.mobile || Useragnt.tablet) return;

        let _number = +this.kv.status.index + 1;

        this.kv.canvas.el = document.getElementById("js__canvas-detail"+this.kv.status.index);
        this.kv.canvas.length = Number(this.kv.canvas.el.getAttribute('data-number')) + 1;
        this.kv.canvas.ctx = this.kv.canvas.el.getContext("2d");
        this.kv.canvas.count = 0;
        this.kv.canvas.width = 2048;
        this.kv.canvas.height = 1024;

        if(this.loadedImg[this.kv.status.index]){ //loaded

            this.kv.status.rendering = true;
            TweenMax.set(this.kv.detail.querySelector('.is-current'), {
                delay:1,
                className:"+=is-comp"
            });

        }else{ //firstload

            // this.kv.srcList = [];
            // this.kv.imgList = [];

            for(let i=0; this.kv.canvas.length>i; i++) {
                this.kv.srcList[this.kv.status.index][i] = 'assets/img/top/kv/'+_number+'/detail_man'+i+'.png'
            }

            for (let i = 0; i < this.kv.canvas.length; ++i) {
                this.kv.imgList[this.kv.status.index][i] = new Image();
                this.kv.imgList[this.kv.status.index][i].onload = () => {
                    this.loaded();
                }
                //this.kv.imgList[this.kv.status.index][i].onerror = console.log('エラー');
                this.kv.imgList[this.kv.status.index][i].src = this.kv.srcList[this.kv.status.index][i];
            }

        }

        this.count = 0;
        this.reset();

    }

    loaded() {

        if (++this.kv.canvas.count === this.kv.canvas.length) {

            this.loadedImg[this.kv.status.index] = true; //すでに読込みが終わったシーンはtrueに
            this.kv.status.rendering = true;

        }

    }

    reset() {

        this.kv.canvas.el.width = 2048;
        this.kv.canvas.el.height = 1024;

    }

    start() {

        if(Useragnt.mobile || Useragnt.tablet) return;

        this.count = 0;
        this.reset();
        this.loop = false;
        this.kv.canvas.i = 0;
        this.kv.canvas.ctx.drawImage(this.kv.imgList[this.kv.status.index][0], 0, 0);

    }

    render(){

        this.count ++;
        if( (this.count % 2) != 0) return;

        if(this.kv.imgList[this.kv.status.index][this.kv.canvas.i]){
            this.reset();
            this.kv.canvas.ctx.drawImage(this.kv.imgList[this.kv.status.index][this.kv.canvas.i], 0, 0);
            if(this.kv.status.index === 6 && this.loop){
                if(this.kv.canvas.i < this.kv.canvas.length - 1){
                    this.kv.canvas.i ++;
                }else{
                    this.kv.canvas.i = 19;
                }
            }else{
                this.kv.canvas.i = ++ this.kv.canvas.i % this.kv.canvas.length;
                if(this.kv.canvas.i === this.kv.canvas.length - 1) this.loop = true;
            }
        }


    }


}